import { render, staticRenderFns } from "./task-module.vue?vue&type=template&id=2bc46552&scoped=true&lang=pug&"
import script from "./task-module.vue?vue&type=script&lang=js&"
export * from "./task-module.vue?vue&type=script&lang=js&"
import style0 from "./task-module.vue?vue&type=style&index=0&id=2bc46552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc46552",
  null
  
)

export default component.exports